export default function isEven(n: number): boolean {
  return n % 2 === 0;
}
